import {
  Row,
  Col,
  Card,
  Alert,
  Image,
  Button,
  Container,
} from "react-bootstrap";
import React from "react";
import { useLocation } from "react-router-dom";
import uploadedImageUrl from "../../assets/images/SuccessCheck.png";
import { getLanguage } from "../../utils/localization";

const Status = () => {
  const location = useLocation();
  const { createdDate, phoneNumber } = location.state || {};

  const serverDate = new Date(`${createdDate} UTC`);
  const localDateFormatted = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(serverDate);
  const localDate = localDateFormatted.replace(",", "").replace(" ", " ");

  return (
    <Container className="text-center my-5">
      <Card className="borderless text-center" style={{ borderRadius: 8 }}>
        <Card.Body>
          <Row>
            <Col>
              <Alert variant="success">
                <Alert.Heading style={{ fontFamily: '"Poppins", serif' }}>
                  {getLanguage("STATUS.UPLD_SCSS")}
                </Alert.Heading>
                <p style={{ fontFamily: '"Poppins", serif' }}>
                  {getLanguage("STATUS.REC_UPLD_SCSS")}
                </p>
              </Alert>
              <Image
                className="mt-4"
                src={uploadedImageUrl}
                alt="Uploaded"
                style={{ height: 150, width: 150 }}
                fluid
              />

              <div>
                {phoneNumber && (
                  <p
                    className="lead mt-4"
                    style={{ fontFamily: '"Poppins", serif' }}
                  >
                    {getLanguage("STATUS.USR_MBL_NMBR")} {phoneNumber}
                  </p>
                )}
                {localDate && (
                  <p
                    className="lead"
                    style={{ fontFamily: '"Poppins", serif' }}
                  >
                    {getLanguage("STATUS.CRTD_DTE")} {localDate}
                  </p>
                )}
              </div>
              <p
                className="lead mt-4"
                style={{ fontFamily: '"Poppins", serif' }}
              >
                {getLanguage("STATUS.SCSS_MSG")}
              </p>
              <Button
                variant="primary"
                href="/"
                className="mt-3 p-3 w-25"
                style={{ fontFamily: '"Poppins", serif' }}
              >
                {getLanguage("STATUS.GO_HME_BTN")}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Status;
